import { SHA256 } from "jscrypto/es6/SHA256";

export class CryptoUtils {
    public static SHA256Hash = (input: string): string => {
        return SHA256.hash(input).toString();
    };
}
